import React from 'react';

import HeartChunkySvg from 'eventbrite_design_system/iconography/icons/HeartChunky';
import TicketChunkySvg from 'eventbrite_design_system/iconography/icons/TicketChunky';

import {getAnalyticsClickHandler} from '@eb/site-analytics';

import {gettext} from '../../translations';

const ACTION_DISCOVER = 'Discover';
const CATEGORY_HEADER = 'header';

// These were originally exported from core-js-global
// But ever since the refactor to @eb/site-header, they
// seem to have removed these.
export const getLikesQuickLinks = (
    serverUrl,
    ebDomain,
    requestPath,
    publicId,
) => [{
    url: `${serverUrl}/u/${publicId}/favorites/events`,
    content: gettext('Likes'),
    iconType: <HeartChunkySvg />,

    onClick: getAnalyticsClickHandler({
        requestPath,
        action: ACTION_DISCOVER,
        category: CATEGORY_HEADER,
    }, {
        checkpointName: 'discover_header_link_clicked',
        domain: ebDomain,
    }),
}];

export const getMyTicketsQuickLinks = (
    serverUrl,
    ebDomain,
    requestPath,
    publicId,
) => [{
    url: `${serverUrl}/u/${publicId}/`,
    content: gettext('Tickets'),
    iconType: <TicketChunkySvg />,

    onClick: getAnalyticsClickHandler({
        requestPath,
        action: ACTION_DISCOVER,
        category: CATEGORY_HEADER,
    }, {
        checkpointName: 'discover_header_link_clicked',
        domain: ebDomain,
    }),
}];
